import { styled } from "styled-components";

import { RedCircleErrorIcon } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";

export const ErrorModal = () => {
  const translate = useTranslate();
  const { localisedMessageKey, message } = useSelector(getModalParams) as ModalParams<"Error">;

  return (
    <>
      <ModalHeader title={translate("app.error.unknown.title")} />
      <Container>
        <ErrorIcon />
        <Text>{message ?? translate(localisedMessageKey ?? "app.auth.error")}</Text>
      </Container>
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const ErrorIcon = styled(RedCircleErrorIcon)`
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.fillPrimary};
  flex-shrink: 0;
  width: 60px;
`;

const Text = styled.p`
  font-size: 1.1rem;
  line-height: 1.8rem;
  margin: 0 0 0 1.3rem;
  text-align: left;
`;
